<template>
  <div class="cookie-modal-main">
    <div class="cookie-modal-main-content">
      <div class="cookie-modal-container">
        <div class="col-12 cookie-modal-header">
          <h4>{{ t('cookies.settings') }}</h4>
          <p>{{ t('cookies.settings.main', {params: [{shopname: eshopName}]}) }}</p>
        </div>
        <div class="col-12 cookie-check-row">
          <div class="cookies_checkbox">
            <div class="cookie_switch-container">
              <input
                v-model="functionalityStorage"
                type="checkbox"
                class="cookie_switch"
                id="CookiesRequiredCheckbox"
                value="1"
                :checked="getFunctionalityStorageState"
                disabled
              >
              <label
                for="CookiesRequiredCheckbox"
              ><strong>{{ t('cookies.settings.cookies_required') }}</strong></label>
            </div>
            <p>{{ t('cookies.settings.part.functionality') }}</p>
          </div>
          <div class="cookies_checkbox">
            <div class="cookie_switch-container">
              <input
                v-model="analyticsStorage"
                type="checkbox"
                class="cookie_switch"
                id="CookiesAnalyticsCheckbox"
                value="1"
                :checked="getAnalyticsStorageState"
              >
              <label
                for="CookiesAnalyticsCheckbox"
              ><strong>{{ t('cookies.settings.cookies_analytics') }}</strong></label>
            </div>
            <p>{{ t('cookies.settings.part.analytics') }}</p>
          </div>
          <div class="cookies_checkbox">
            <div class="cookie_switch-container">
              <input
                v-model="adStorage"
                type="checkbox"
                class="cookie_switch"
                id="CookiesAdvertisingCheckbox"
                value="1"
                :checked="getAdStorageState"
              >
              <label
                for="CookiesAdvertisingCheckbox"
              ><strong>{{ t('cookies.settings.cookies_advertising') }}</strong></label>
            </div>
            <p>{{ t('cookies.settings.part.advertising', {params: [{shopname: eshopName}]}) }}</p>
          </div>
          <div class="cookies_checkbox">
            <div class="cookie_switch-container">
              <input
                v-model="personalizationStorage"
                type="checkbox"
                class="cookie_switch"
                id="CookiesPersonalizationCheckbox"
                value="1"
                :checked="getPersonalizationStorageState"
              >
              <label
                for="CookiesPersonalizationCheckbox"
              ><strong>{{ t('cookies.settings.cookies_personalization') }}</strong></label>
            </div>
            <p>{{ t('cookies.settings.part.personalization') }}</p>
          </div>
        </div>
        <div class="col-12 cookie-modal-header">
          <p v-html="t(
                'cookies.settings.more',
                { params: [{ shopname: eshopName, policyurl: policyUrl }] })"
          ></p>
        </div>
        <div class="col-12 cookie-modal-actions-row">
          <div class="row row-mlr-0">
            <div class="col-12 cookie-modal-action-col">
              <button class="cookie-modal-btn" data-action="consentToCookies" @click="postCookieSettings">
                <span data-action="consentToCookies">{{ t('cookies.settings.consent') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  ConsentOptionsEnum,
  ConsentStorageEnum,
  CookieConsentNamesEnum
} from '../../../../vue/cookies/store/cookiesModule'
import { setCookie } from '../../../js/es6/utilities/cookie-access'

export default {
  name: 'CookieSettings',
  computed: {
    ...mapGetters('cookies', [
      'getAdStorage',
      'getAnalyticsStorage',
      'getFunctionalityStorage',
      'getPersonalizationStorage'
    ]),
    adStorage: {
      get () {
        return this.getAdStorageState
      },
      set (value) {
        this.setConsentValueByName({
          consentName: ConsentOptionsEnum.CONSENT_AD_STORAGE,
          consentValue: value
        })
      }
    },
    analyticsStorage: {
      get () {
        return this.getAnalyticsStorageState
      },
      set (value) {
        this.setConsentValueByName({
          consentName: ConsentOptionsEnum.CONSENT_ANALYTICS_STORAGE,
          consentValue: value
        })
      }
    },
    functionalityStorage: {
      get () {
        return this.getFunctionalityStorageState
      },
      set (value) {
        this.setConsentValueByName({
          consentName: ConsentOptionsEnum.CONSENT_FUNCTIONALITY_STORAGE,
          consentValue: value
        })
      }
    },
    personalizationStorage: {
      get () {
        return this.getPersonalizationStorageState
      },
      set (value) {
        this.setConsentValueByName({
          consentName: ConsentOptionsEnum.CONSENT_PERSONALIZATION_STORAGE,
          consentValue: value
        })
      }
    },
    getAdStorageState () {
      if (this.getAdStorage.value === null) {
        return this.getAdStorage.defaultValue === ConsentStorageEnum.DENIED
      }
      return this.getAdStorage.value === ConsentStorageEnum.GRANTED
    },
    getFunctionalityStorageState () {
      if (this.getFunctionalityStorage.value === null) {
        return this.getFunctionalityStorage.defaultValue === ConsentStorageEnum.GRANTED
      }
      return this.getFunctionalityStorage.value === ConsentStorageEnum.GRANTED
    },
    getAnalyticsStorageState () {
      if (this.getAnalyticsStorage.value === null) {
        return this.getAnalyticsStorage.defaultValue === ConsentStorageEnum.DENIED
      }
      return this.getAnalyticsStorage.value === ConsentStorageEnum.GRANTED
    },
    getPersonalizationStorageState () {
      if (this.getPersonalizationStorage.value === null) {
        return this.getPersonalizationStorage.defaultValue === ConsentStorageEnum.DENIED
      }
      return this.getPersonalizationStorage.value === ConsentStorageEnum.DENIED
    },
    eshopName () {
      return this.t('hct.eshop.name')
    },
    policyUrl () {
      return this.t('hct.eshop.policy.url')
    }
  },
  methods: {
    ...mapActions('cookies', [
      'setConsentValueByName',
      'updateCookie'
    ]),
    postCookieSettings () {
      setCookie(
        CookieConsentNamesEnum.CONSENT_STATUS,
        true,
        365
      ).then(() => {
        this.$root.$emit('cookies-modal-close')
      })
    }
  }
}
</script>
